import { PaymentMethodUid } from "@/services/marketplace/paymentMethod";
import { faCreditCard, faMoneyBillWave } from "@fortawesome/pro-solid-svg-icons";

export function usePaymentMethodIcon(paymentMethodUid: PaymentMethodUid) {
  return computed(() => {
    if (paymentMethodUid === PaymentMethodUid.OnlinePayment) {
      return faMoneyBillWave;
    } else if (paymentMethodUid === PaymentMethodUid.Card) {
      return faCreditCard;
    } else {
      throw new Error("DEV: Should not happen. Unknown payment method.");
    }
  });
}
